import { Reducer } from 'redux';
import { CREATE_CHANGE_REQUEST } from '../components/create-change-request/create-change-request-actions';
import * as Actions from '../actions';
import { IPoItemsState } from '../interfaces/po-items-state';
import { ItemState } from '@/app-constants';

//#region Details Revised Tab State

const poItemsRevisedInitialState: IPoItemsState = {
  currentPage: 1,
  error: null,
  loading: false,
  poItems: [],
  totalItemCount: 0
}

export const poItemsRevisedReducer: Reducer<IPoItemsState> = (state: IPoItemsState = poItemsRevisedInitialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.POITEMS_REVISED_ACTIONS.FAILURE:
      return { ...state, loading: false, error: action.error };

    case Actions.POITEMS_REVISED_ACTIONS.REQUEST:
      return { ...state, loading: true };

    case Actions.POITEMS_REVISED_ACTIONS.SUCCESS:
      return {
        ...state,
        poItems: [...state.poItems, ...payload.purchaseOrderItems],
        loading: false,
        totalItemCount: payload.totalCount,
        currentPage: payload.currentPage
      };

    case CREATE_CHANGE_REQUEST.SUCCESS:
      if (payload.stateId === ItemState.Revised) {
        const newItems = state.poItems.filter(item => item.purchaseOrderItemId !== payload.purchaseOrderItemId);
        return { ...state, poItems: newItems };
      }

      return state;

    case Actions.PO_ITEMS_ACTIONS.SEARCH:
    case Actions.PO_DETAILS_ACTIONS.CLEAR:
      return { ...state, poItems: [], currentPage: 1 };

    case Actions.PO_ITEMS_ACTIONS.CONFIRM_SELECTED_SUCCESS:
      let itemsToKeep = [];
      if (action.payload.excludedPurchaseOrderItemIds.length) {
        itemsToKeep = state.poItems.filter(item => action.payload.excludedPurchaseOrderItemIds.includes(item.purchaseOrderItemId));
      } else if (action.payload.purchaseOrderItemIds.length) {
        itemsToKeep = state.poItems.filter(item => !action.payload.purchaseOrderItemIds.includes(item.purchaseOrderItemId));
      }

      return {
        ...state,
        poItems: itemsToKeep
      };

      case Actions.PO_ITEMS_ACTIONS.FILTER:
      let newItems = [];
      if (action.payload.excludedPurchaseOrderItemIds) {
        newItems = state.poItems.filter(item => action.payload.excludedPurchaseOrderItemIds.includes(item.purchaseOrderItemId));
      } else {
        newItems = state.poItems.filter(item => !action.payload.purchaseOrderItemIds.includes(item.purchaseOrderItemId));
      }

      return { ...state, poItems: newItems };

      default:
      return state;
  }
}

//#endregion
